var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRightGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.06 16.36"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".arrow-right-grey_svg__cls-1{fill:none;stroke:#b3b3b3;stroke-miterlimit:10;stroke-width:2px}.arrow-right-grey_svg__cls-2{fill:#b3b3b3}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-grey_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-grey_svg__LATEST"
  }, /*#__PURE__*/React.createElement("path", {
    className: "arrow-right-grey_svg__cls-1",
    d: "M0 8.18h37.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "arrow-right-grey_svg__cls-2",
    d: "M31.26 16.36l-1.36-1.47 7.22-6.71-7.22-6.71L31.26 0l8.8 8.18-8.8 8.18z"
  })))));
}

export default "data:image/svg+xml;base64,CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNDAuMDYgMTYuMzYiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDpub25lO3N0cm9rZTojYjNiM2IzO3N0cm9rZS1taXRlcmxpbWl0OjEwO3N0cm9rZS13aWR0aDoycHg7fS5jbHMtMntmaWxsOiNiM2IzYjM7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMQVRFU1QiPjxsaW5lIGNsYXNzPSJjbHMtMSIgeTE9IjguMTgiIHgyPSIzNy44OSIgeTI9IjguMTgiLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMzEuMjYgMTYuMzYgMjkuOSAxNC44OSAzNy4xMiA4LjE4IDI5LjkgMS40NyAzMS4yNiAwIDQwLjA2IDguMTggMzEuMjYgMTYuMzYiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgArrowRightGrey as ReactComponent };